import { render, staticRenderFns } from "./NewPasswordPage.vue?vue&type=template&id=291becba&scoped=true"
import script from "./NewPasswordPage.vue?vue&type=script&lang=ts"
export * from "./NewPasswordPage.vue?vue&type=script&lang=ts"
import style0 from "./NewPasswordPage.vue?vue&type=style&index=0&id=291becba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291becba",
  null
  
)

export default component.exports